import type { MsgDeskLoadingProps } from '@/deskUiSkeletons/Shared/SharedSurfaceContext'

export function MusicLoading({ contract, variant = 'page', label, className = '' }: MsgDeskLoadingProps) {
  const text = label || (variant === 'button' ? 'Saving' : 'Loading music')
  const spinner = <span aria-hidden="true" className="inline-block h-3.5 w-3.5 animate-spin rounded-full border-2 border-current border-r-transparent" />
  const initiallyHidden = contract === 'editor.loading' ? { display: 'none' } : undefined

  if (variant === 'inline' || variant === 'button') {
    return <span data-md-contract={contract} style={initiallyHidden} className={`inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-[#6b3f24] ${className}`} role="status" aria-live="polite">{spinner}<span>{text}</span></span>
  }

  if (variant === 'overlay') {
    return <div data-md-contract={contract} className={`inline-flex items-center gap-3 rounded-2xl border border-[#d8c4b0] bg-white px-4 py-3 text-sm font-semibold text-[#6b3f24] shadow-xl ${className}`} role="status" aria-live="polite">{spinner}<span>{text}</span></div>
  }

  return (
    <div
      data-md-contract={contract}
      className={`flex min-h-screen w-full items-center justify-center bg-[#f7f4ee] text-xs font-semibold uppercase tracking-[0.22em] text-[#6b3f24] ${className}`}
      role="status"
      aria-live="polite"
    >
      {spinner}{text}
    </div>
  )
}
